import React from 'react';

import Authenticated from './Authenticated';
import AuthenticatedNativo from './AuthenticatedNativo';
import { AuthenticatedOTP } from './AuthenticatedOTP';
import { AuthenticatedZonda } from './AuthenticatedZonda';

import {
  enableZondaAuth,
  isShouldCheckLoggedInNative,
  setShouldCheckLoggedInNative,
} from '@/services';
import { isNativeApp } from '@/utils/nativeBridge';

/**
 * ver doc en useAuth
 * @link {useAuth}
 */
const AuthenticatedWrapper: React.FC = React.memo(() => {
  const isNative = isNativeApp();
  const params = new URLSearchParams(location.search);
  const hashLogin: string | null =
    params.get('hashLogin') || params.get('hash');
  if (hashLogin) {
    setShouldCheckLoggedInNative(false);
  }
  const checkSessionJava = isShouldCheckLoggedInNative();

  if (isNative || checkSessionJava) {
    return <AuthenticatedNativo />;
  } else if (hashLogin) {
    return <AuthenticatedOTP hashLogin={hashLogin || undefined} />;
  } else if (enableZondaAuth) {
    return <AuthenticatedZonda />;
  } else {
    return <Authenticated />;
  }
});

AuthenticatedWrapper.displayName = 'AuthenticatedWrapper';

export default AuthenticatedWrapper;
